import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {map} from "rxjs/operators";

// Remove when https://github.com/angular/angular/pull/18466 gets merged. (fixed in >4.4.2)

@Injectable()
export class WA18396Interceptor implements HttpInterceptor {
    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.responseType == 'json') {
            req = req.clone({ responseType: 'text' });

            return next.handle(req).pipe(map(response => {
                if (response instanceof HttpResponse) {
                    response = response.clone<any>({ body: response.body ? JSON.parse(response.body) : response.body });
                }

                return response;
            }));
        }

        return next.handle(req);
    }
}
